import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "referral",
  "use": "referral-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"referral\"><circle cx=\"8\" cy=\"4.862\" r=\"3.182\" stroke=\"currentColor\" /><path stroke=\"currentColor\" stroke-linecap=\"round\" d=\"M8.959 12.04c0 1.077-.91 2.136-1.949 2.136-.099.014-2.501 0-2.604 0a2.136 2.136 0 1 1 0-4.272h1.73\" /><path stroke=\"currentColor\" stroke-linecap=\"round\" d=\"M7.041 11.91c0-1.077.91-2.136 1.949-2.136.099-.014 2.501 0 2.604 0a2.136 2.136 0 1 1 0 4.272h-1.73\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol